import { useReport } from "../hooks/useReport.js";
import React, { useContext } from "react";
import { Loading } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Reports/contexts/ReportContext.tsx
var ReportContext = React.createContext(void 0);
var ReportContextProvider = ({ children, LoadingComponent, reportId }) => {
	const { data, loading } = useReport({ reportId });
	if (!data?.report) return LoadingComponent ? /* @__PURE__ */ jsx(LoadingComponent, {}) : /* @__PURE__ */ jsx(Loading, {
		message: "Loading Report",
		overlay: true
	});
	return /* @__PURE__ */ jsx(ReportContext.Provider, {
		value: {
			loading,
			report: data?.report,
			reportId,
			reportType: data?.reportType
		},
		children
	});
};
function useReportContext(ctxRequired) {
	const ctx = useContext(ReportContext);
	if (ctxRequired && !ctx) throw new Error("context is required for useReportContext()");
	return ctx;
}
//#endregion
export { ReportContext, ReportContextProvider, useReportContext };

//# sourceMappingURL=ReportContext.js.map